module.exports = __webpack_public_path__ + "img/logo5.88a2f704.png";